import tingle from 'tingle.js';
import 'tingle.js/dist/tingle.css';
import brightcovePlayerLoader from '@brightcove/player-loader';
const resourceList = () => {
  // window.onload = function() {
  //   $('.loading').hide()
  // };

  if ($('.resource-items').length === 0) return;
  const resourceItems = $('.resource-item');
  const pageItemsSize = 12; // set 12 to see the pagination
  let currentPage = 1;
  const pageCount = Math.ceil(resourceItems.length / pageItemsSize);
  let player = null;

  // if resource items lenght smaller than page item size, hide the pagination
  if (resourceItems.length <= pageItemsSize) {
    $("#pagination").hide();
  }
  
  // dynamic add in pagination items
  for(let i = 0 ; i < pageCount; i++){
    $("#pagination").append('<li><span>'+(i+1)+'</span></li> ');
    if(i>pageItemsSize){
      $("#pagination li").eq(i).hide();
    }
  }

  const prev = $("<li/>").addClass("prev").html("Prev").click(function(){
    currentPage--;
    paginationActions(currentPage)
    // updatePaginationClass(currentPage)
    // // $("#pagination li span").removeClass("current");
    // // $("#pagination li span").eq(currentPage-1).addClass("current");
    // showPage(currentPage);
    // slide();
  });

  prev.hide();

  const next = $("<li/>").addClass("next").html("Next").click(function(){
    currentPage++;
    paginationActions(currentPage)
  });

  // prepend prev and next arrows
  $("#pagination").prepend(prev).append(next);

  function slide() {
    if(currentPage == 1){
      next.show();
      prev.hide();
    }else if(currentPage == pageCount ){
      next.hide();
      prev.show();
    }else{
      next.show();
      prev.show();
    }
  }

  function showPage (page) {
    resourceItems.hide();
    resourceItems.each(function(n) {
      if (n >= pageItemsSize * (page - 1) && n < pageItemsSize * page)
          $(this).show();
    });
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });    
  }

  function updatePaginationClass(currentPage) {
    $("#pagination li span").removeClass("current");
    $("#pagination li span").eq(currentPage-1).addClass("current");
  }

  function paginationActions(currentPage) {
    updatePaginationClass(currentPage)
    showPage(currentPage);
    slide();
  }

  // default show first page
  showPage(1);
  // default first page is current page
  $("#pagination li span").eq(0).addClass("current");

  // pagination item click event
  $("#pagination li span").click(function() {
    $("#pagination li span").removeClass("current");
    $(this).addClass("current");
    const currentNum = parseInt($(this).text());
    currentPage = currentNum;
    showPage(currentNum);
    slide();
  });

  // modal trigger
  // console.log(tingle, 'tingle')
  const modalEl = new tingle.modal({
      footer: false,
      stickyFooter: false,
      closeMethods: ['overlay', 'button', 'escape'],
      closeLabel: "Close",
      cssClass: ['organon-modal', 'resource-item-modal'],
      beforeOpen: function() {
          console.log('beforeOpen');
      },
      onOpen: function() {
          console.log('modal open');
      },
      onClose: function() {
        // if player exist, destory player when modal closed
        if (player) {
          // Dispose of the player instance
          player.dispose();
          console.log('Player instance destroyed successfully.');
        }
          console.log('modal closed');
      },
      beforeClose: function() {
          // here's goes some logic
          // e.g. save content before closing the modal
          return true; // close the modal
      }
  });

      
  $('.resource-item-modal .tingle-modal__close').detach().prependTo('.resource-item-modal .tingle-modal-box');
  $('.open-modal').on('click', (e) => {
    const currentTargetDataTrigger = e.currentTarget?.dataset?.trigger || '';
    if(currentTargetDataTrigger) {
      modalEl.setContent(document.querySelector(`[data-content="${currentTargetDataTrigger}"]`).innerHTML);
      const content = $(modalEl.modalBoxContent);
      const videoContainer = content.find('.video-container');
      videoContainer.append('<div class="loading"><div class="loader"></div></div>');
      modalEl.open();
      const accountId = content.find('.modal-section').data('account-id');
      const videoId = content.find('.modal-section').data('video-id');
      // const jsScript = content.find('.modal-section').data('js');
      // $.getScript(jsScript)
      brightcovePlayerLoader({
        refNode: content.find('.video-item')[0],
        refNodeInsert: 'replace',
        accountId: accountId,
        playerId: 'default',
        embedId: 'default',
        videoId: videoId
      })
        .then(function(success) {
          player = success.ref;
          content.find('.loading').remove()
          bindClickEvents();
        })
        .catch(function(error) {
          console.log(error)
        });
    }
  })

  function bindClickEvents() {
    //binding footer ctas after copying content to a modal
    $(document).on('click touchend', '.prev-step, .next-step', (e) => {
      const currentTargetDataTrigger = e.currentTarget?.dataset?.goto || '';
      if(currentTargetDataTrigger) {
        const modalOuter = $(e.currentTarget).closest('.tingle-modal-box__content');
        const modalTitle = modalOuter.find('.header');
        modalEl.close();
        modalEl.setContent(document.querySelector(`[data-content="${currentTargetDataTrigger}"]`).innerHTML);
        const content = $(modalEl.modalBoxContent);
        const videoContainer = content.find('.video-container');
        videoContainer.append('<div class="loading"><div class="loader"></div></div>');
        modalEl.open();
        const accountId = content.find('.modal-section').data('account-id');
        const videoId = content.find('.modal-section').data('video-id');

        brightcovePlayerLoader({
          refNode: content.find('.video-item')[0],
          refNodeInsert: 'replace',
          accountId: accountId,
          playerId: 'default',
          embedId: 'default',
          videoId: videoId
        })
          .then(function(success) {
            player = success.ref;
            console.log('player', player);
            content.find('.loading').remove()
          })
          .catch(function(error) {
            console.log(error)
          });

        if ($(e.currentTarget).hasClass('next-step')) {
          resourceItems.each(function(idx, item) {
            if ($(item).find('.title').text().trim() === modalTitle.text().trim()) {
              if ((idx+1) % pageItemsSize === 0) {
                currentPage++;
                paginationActions(currentPage)
              }
            }
          })
        }

        if ($(e.currentTarget).hasClass('prev-step')) {
          resourceItems.each(function(idx, item) {
            if ($(item).find('.title').text().trim() === modalTitle.text().trim()) {
              if (idx % pageItemsSize === 0) {
                currentPage--;
                paginationActions(currentPage)
              }
            }
          })
        }
      }
    });

    // click on cover image to hide the video
    $(document).on('click touchend', '.video-cover-image', (e) => {
      $(e.currentTarget).hide();
      player.ready(function () {
        player.play();
      });
    });
  }
};

export default resourceList;
